import React, {
	useContext,
	useEffect,
	useState
} from 'react';
import BC
	from "../components/BrailleCharacter";
import {DataContext} from "../store/DataProvider";
import {useTranslation} from "react-i18next";

const RulesView = props => {
	const {t} = useTranslation();
	const context = useContext(DataContext)
	const [rule, setRule] = useState({})
	useEffect(() => {
		if (props.category !== "" && props.index !== "") {
			setRule(context.state.rules.getRule(props.system, props.category, props.index));
		}
	}, [context, props.system, props.category, props.index])
	const renderTexts = () => {
		var textViews = [];
		if (rule.hasOwnProperty("text")) {
			var texts = rule.text.split("\n");
			for (let text in texts) {
				if (texts[text] !== "") {
					textViews.push(
							<div id={text}>
								{texts[text]}
							</div>
					)
				} else {
					textViews.push(
							<br />
					)
				}
			}
		}
		return textViews
	}
	const renderCharacters = () => {
		let characters = [];
		if (rule.hasOwnProperty("examples")) {
			for (let index in rule.examples[0].dots) {
				if (index > 0) {
					if (rule.examples[0].dots[index] > 0) {
						characters.push(
								<BC
										key={index}
										character={
											rule.examples[0].dots.length > 0
													? rule.examples[0].dots[index]
													: 0
										}
										isReading={true}
										isPartOfMultipleCharacter={rule.examples[0].dots.length > 1}
										isEuroBraille={props.system === "euro"}
										characterIndex={index}
								/>
						);
					}
				} else {
					characters.push(
							<BC
									key={index}
									character={
										rule.examples[0].dots.length > 0
												? rule.examples[0].dots[index]
												: 0
									}
									isReading={true}
									isPartOfMultipleCharacter={rule.examples[0].dots.length > 1}
									isEuroBraille={props.system === "euro"}
									characterIndex={index}
							/>
					);
				}
			}
		}
		return characters
	}
	const renderExample = () => {
		let example = [];
		if (rule.hasOwnProperty("examples")) {
			example.push(
					<div key={1}>
						{t('rules.example')}: {rule.examples[0].title}
					</div>
			)
		}
		return example;
	}
	return (
			<div>
				<div>
					{renderTexts()}
				</div>
				<div>
					{renderExample()}
				</div>
				<div className="HStack">
					{renderCharacters()}
				</div>

			</div>
	)
}
export default RulesView;